import nxModule from 'nxModule';
import _ from 'lodash';

import templateUrl from './substituted-value-condition.template.html';
import './substituted-value-condition.style.less';

class SubstitutedValueConditionComponent {
  constructor($scope) {
    this.$scope = $scope;
  }

  $onInit() {
    this.type = 'SUBSTITUTED_VALUE';

    if (!this.isConditionAlreadyDefined()) {
      return;
    }

    this.dictionaryEntries = this.conditions[this.propertyDefinition.property].options
        .map((op) => ({ label: op, value: op }));

    this.$scope.$watchCollection('$ctrl.conditions', () => {
      if (!this.propertyDefinition) {
        return;
      }

      if (!this.isConditionAlreadyDefined()) {
        this.setDefaultValues();
      } else {
        this.fetchExistingValues();
      }
    });

    this.valueChanged = () => {
      this.saveValues();
    };
  }

  setDefaultValues() {
    this.model = {param: null};
  }

  fetchExistingValues() {
    this.model = this.conditions[this.propertyDefinition.property].model;
  }

  /**
   * Gets the only one allowed predicate for this type
   *
   * @returns {*}
   */
  getSupportedPredicate() {
    return this.propertyDefinition.supportedPredicates[0];
  }

  saveValues() {
    this.conditions[this.propertyDefinition.property] = {
      properties: [this.propertyDefinition.property],
      type: this.propertyDefinition.type,
      code: this.propertyDefinition.code,
      model: this.model,
      predicate: this.getSupportedPredicate()
    };
  }

  isConditionAlreadyDefined() {
    return _.has(this.conditions, this.propertyDefinition.property);
  }
}

nxModule.component('substitutedValueCondition', {
  templateUrl,
  bindings: {
    conditions: '=',
    propertyDefinition: '<'
  },
  controller: SubstitutedValueConditionComponent
});
